<template>
  <div id="Ticket" class="q-pa-md">
    <crud-layout
      ref="crudLayout"
      :name="name"
      :interface="nmInterface"
      :id="id"
      :page-detail="ticketPage"
      @page-added="pageAdded"
      :page-table="pageTable"
    >
    <page-search
        slot="page-search"
        slot-scope="{ params, forms, showMessage, actionButton }"
        :params="params"
        :forms="formAnalyze(forms)"
        @action-button="actionButton"
        @show-message="showMessage"
      ></page-search>
    </crud-layout>

    <q-dialog v-model="visible" persistent>
        <q-card>
          <q-card-section class="row justify-center">
            <q-icon name="error_outline" color="warning" size="4.5em"></q-icon>
          </q-card-section>
          <q-card-section class="row justify-center q-mx-lg">
            <span class="text-subtitle1 text-weight-medium text-center">{{ $gettext('MTR_WRITE_OFF_CONFIRM_DIALOG') }}</span>
          </q-card-section>
          <q-card-actions class="justify-center q-pa-md q-my-sm">
            <q-btn :label="$gettext('DIALOGS_NO')" color="grey-7" v-close-popup class="q-px-lg" />
            <q-btn :label="$gettext('DIALOGS_YES')" color="info" v-close-popup @click="writeOffMtr()" class="q-px-lg" />
          </q-card-actions>
        </q-card>
    </q-dialog>
    <image-preview :visible="imagePreviewVisible" :title="imagePreviweTitle" :blobImage="imagePreviweBlob" @input="value => imagePreviewVisible = value" />
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { MtrRepository } from '../mtr/MtrRepository'
import { TicketRepository } from './TicketRepository'
import { repository } from 'src/jtech'
import TicketPage from './TicketPage.vue'
import ImagePreview from './ImagePreview.vue'
import TicketPageTable from './TicketPageTable.vue'
import AutocompleteSelect from './AutocompleteSelect.vue'

const { CrudLayout, action, pageSearch } = JtCrud

@Component({
  name: 'Ticket',
  components: {
    CrudLayout, TicketPage, ImagePreview, TicketPageTable, AutocompleteSelect, pageSearch
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class Ticket extends Vue {
  visible = false
  imagePreviewVisible = false
  imagePreviweTitle = ''
  imagePreviweBlob = ''

  params = {}
  searchPage = null
  containerTicket = { nmPage: '' }

  selectedAutocompleteValue = null
  currentSearchTerm = ''
  isAutocompleteLoading = false
  disableFormSubmission = false

  preLoadedAutocompleteOptions = [
    { nmAtributo: 'generator', options: [] },
    { nmAtributo: 'client', options: [] },
    { nmAtributo: 'residue', options: [] },
    { nmAtributo: 'carrier', options: [] }
  ]

  get pageTable () {
    return TicketPageTable
  }

  mounted () {
    setTimeout(() => {
      this.containerTicket = this.$refs.crudLayout?.state?.containers?.ticket
    }, 1000)
    this.$refs.crudLayout.onButton('btConfirmar', this.actionButtonComposition)
    this.$refs.crudLayout.onButton('btExecutar', this.actionButtonComposition)
    this.$refs.crudLayout.onButton('ticketImage.imagePreview', this.handleImagePreview)
    this.searchPage = this.$refs.crudLayout?.state?.containers['ticket']?.pages[0]
    this.__loadTicketSearch()
  }

  @Watch('nmPage')
  watchNmPage (nmPage) {
    const currentPage = this.getCurrentPage(nmPage)
    if (currentPage?.label === 'Detalhar') {
      this.refresh(currentPage)
    }
  }

  get ticketPage () {
    return TicketPage
  }

  async refresh (currentPage) {
    if (currentPage.forms) {
      const dadosForm = currentPage.forms[0]?.dadosForm || currentPage.forms[0]
      const resp = await repository.resolve('ticket.detalhar', { id: dadosForm.id, idAcaoGrid: dadosForm.id })
      currentPage.forms = resp
    }
  }

  get nmPage () {
    return this.containerTicket?.nmPage
  }

  actionButtonComposition (buttonParams) {
    if (buttonParams.button.action === 'mtr.downloadMtr') {
      this.downloadMultiFiles(this.getMtrFileList(buttonParams.page.selectedItems), MtrRepository.downloadMtr, 'pdf')
    } else if (buttonParams.button.action == 'ticketImage.downloadImage') {
      this.downloadMultiFiles(this.getTicketImageFileList(buttonParams.page.selectedItems), TicketRepository.downloadTicketImage, 'png')
    } else if (buttonParams.button.action === 'mtr.writeOff') {
      this.openConfirmModal(buttonParams.params)
    } else {
      this.$emit('action-button', buttonParams.button, buttonParams.params, this)
    }
  }

  async handleImagePreview (buttonParams) {
    this.imagePreviweTitle = buttonParams.params.imageType_nmDescricao
    this.imagePreviweBlob = await TicketRepository.downloadTicketImage(buttonParams.params.id)
    this.imagePreviewVisible = true
  }

  getCurrentPage (nmPage) {
    return this.$refs?.crudLayout?.state?.containers?.ticket?.pages?.find(p => p.name === nmPage)
  }

  async writeOffMtr () {
    const resp = await repository.resolveLogic('mtr.writeOff', this.params)
    const currentPage = this.getCurrentPage(this.nmPage)
    const mtr = currentPage.forms[0].dadosForm.mtrs[this.params.__index]
    mtr.status_nmDescricao = resp.nmDescricao
    mtr.canBeWriteOff = resp.canBeWriteOff
  }

  openConfirmModal (params) {
    this.visible = true
    this.params = params
  }

  pageAdded (pageAdded) {
    this.searchPage = null
    if (pageAdded.name == 'btPesquisar') {
      this.searchPage = pageAdded
    }
    this.__loadTicketSearch()
  }

  __loadTicketSearch () {
    if (this.searchPage && this.$route.params?.billingOrder) {
      const button = { ...this.searchPage.forms[0].buttons[0] }
      button.label = this.$gettext('ORDER') + ' - ' + this.$route.params?.billingOrder
      action.actionButton(button, this.$route.params, this.searchPage, this.$refs.crudLayout)
    }
  }

  getTicketImageFileList (selectedItems) {
    return (selectedItems || []).map(selectedItem => {
      return {
        param: selectedItem.id, fileName: selectedItem.path
      }
    })
  }

  getMtrFileList (selectedItems) {
    return (selectedItems || []).map(selectedItem => {
      return {
        param: selectedItem.code, fileName: `mtr-${selectedItem.code}.pdf`
      }
    })
  }

  downloadMultiFiles (fileList, downloadFunction, extension) {
    fileList.forEach(async file => {
      const blob = await downloadFunction(file.param)
      const fileLink = document.createElement('a')
      const fileURL = window.URL.createObjectURL(blob.data, {
        type: `image/${extension}`
      })
      fileLink.href = fileURL
      fileLink.setAttribute('download', file.fileName)
      document.body.appendChild(fileLink)
      fileLink.click()
      document.body.removeChild(fileLink)
    })
  }

  get nmInterface () {
    return this.interface
  }

  get autoCompleteSelect () {
    return AutocompleteSelect
  }

  formAnalyze (forms) {
    const listAutoCompleteInputs = ['generator', 'client', 'residue', 'carrier']
    forms[0].inputs.map(input => {
      if (listAutoCompleteInputs.includes(input.dataName)) {
        input.component = AutocompleteSelect
        input.type = 'autocomplete-select'
        input.nmAtributoName = input.dependencias[0]
        input.nmAtributo = input.dataName
        input.nmInterface = 'ticket.pesquisaBase'
        input.hint = this.$gettextInterpolate(this.$gettext('HINT'), { label: input.label })
        input.clearable = true
        input.noResultsText = this.$gettext('NO_RESULTS_FOUND')
        input.preLoadedAutocompleteOptions = this.cleanPreLoadedAutocompleteOptions(input.nmAtributo, forms)
      }
      return input
    })
    return forms
  }

  cleanPreLoadedAutocompleteOptions (nmAtributo, forms) {
    const dadosFormAtributo = forms[0]?.dadosForm?.[nmAtributo]
    if (!dadosFormAtributo) {
      const preloadItem = this.preLoadedAutocompleteOptions.find(
        item => item.nmAtributo === nmAtributo
      )
      if (preloadItem) {
        preloadItem.options = []
      }
    }
    return this.preLoadedAutocompleteOptions
  }
}

export default Ticket
</script>

<style>
#Ticket table thead {
  font-size: 0.7rem;
}
#Ticket table span {
  font-size: 0.7rem;
}
#Ticket .jt-datatable{
  height: auto !important;
}
</style>
